// Last summary step to submit form on reviwer/approver config
import * as React from "react"
import { Form } from "antd"
import PropTypes from "prop-types"
import { TextInput } from "components-design-system"

// fields
import AssigneeWorkflowFields from "components/WorkflowModalForm/fields/AssigneeWorkflowFields/AssigneeWorkflowFields"
import FilesFormsWorkFields from "components/WorkflowModalForm/fields/FilesFormsWorkFields/FilesFormsWorkFields"
import ActionItemsWorkflowFields from "components/WorkflowModalForm/fields/ActionItemsWorkflowFields/ActionItemsWorkflowFields"
import InformTeamWorkflowFields from "components/WorkflowModalForm/fields/InformTeamWorkflowFields/InformTeamWorkflowFields"

const ConfirmSendWorkflowStep = ({
  form,
  enableTrackedChanges,
  setEnableTrackedChanges,
  actionItemDisabled,
  setActionItemDisabled,
  informTeam,
  setInformTeam,
  disabled,
  className,
}) => {
  return (
    <div className={`confirm-send-workflow${className ? ` ${className}` : ""}`}>
      {/* assignees */}
      <AssigneeWorkflowFields isEmail />

      {/* action items */}
      <ActionItemsWorkflowFields
        actionItemDisabled={actionItemDisabled}
        setActionItemDisabled={setActionItemDisabled}
      />

      {/* inform team */}
      <InformTeamWorkflowFields
        form={form}
        informTeam={informTeam}
        setInformTeam={setInformTeam}
      />

      {/* review items */}
      <FilesFormsWorkFields
        form={form}
        enableTrackedChanges={enableTrackedChanges}
        setEnableTrackedChanges={setEnableTrackedChanges}
        actionItemDisabled={actionItemDisabled}
        className="workflow-card-wrap confirm-workflow-files-forms"
      />

      {/* comments */}
      <Form.Item
        name={["comment_data", "text"]}
        label="Comments"
      >
        <TextInput
          type="textarea"
          disabled={disabled}
          allowClear
          autoSize={{ minRows: 3, maxRows: 4 }}
        />
      </Form.Item>
    </div>
  )
}

ConfirmSendWorkflowStep.propTypes = {}

export default ConfirmSendWorkflowStep
